

































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import draggable from 'vuedraggable';
import DraggableTreeViewNode from '@/views/structure/DraggableTreeViewNode.vue';

@Component({
    components: {
        DraggableTreeViewNode,
        draggable
    }
})
export default class DraggableTreeView extends Vue {
    @Prop({
        type: Array as () =>
            Array<DisguiseDto.StructureDto<DisguiseDto.StructureDto<any>>>,
        default: () => {
            return [];
        }
    }) value!:
        Array<DisguiseDto.StructureDto<DisguiseDto.StructureDto<any>>>;
    @Prop() group!: string;
    @Prop({
        default: null
    }) selectedItem!: DisguiseDto.StructureDto<any> | null;

    localValue:
        Array<DisguiseDto.StructureDto<DisguiseDto.StructureDto<any>>> = [];
    themeClassName: string = '';

    @Watch('value') valueChanged(
        newValue: Array<DisguiseDto.StructureDto<DisguiseDto.StructureDto<any>>>
    ) {
        this.localValue = [...newValue];
    }

    created() {
        this.localValue = [...this.value];
        this.themeClassName = this.$vuetify.theme.dark ? 'theme--dark' : 'theme--light';
    }

    updateValue(
        value: Array<DisguiseDto.StructureDto<DisguiseDto.StructureDto<any>>>
    ): void {
        this.localValue = value;
        this.$emit('input', this.localValue);
    }

    updateItem(
        itemValue: DisguiseDto.StructureDto<DisguiseDto.StructureDto<any>>
    ): void {
        const index = this.localValue.findIndex((v) => v.id === itemValue.id);
        this.$set(this.localValue, index, itemValue);
        this.$emit('input', this.localValue);
    }

    updateSelectedItem(
        selectedItem: DisguiseDto.StructureDto<DisguiseDto.StructureDto<any>>
    ) {
        this.$emit('selected', selectedItem);
    }

    onChildMoveUp(movedItem: DisguiseDto.StructureDto<any>) {
        if (this.localValue) {
            const index = this.localValue.findIndex(
                (c) => c.id === movedItem.id
            );
            if (index !== 0) {
                this.localValue = this.localValue.map((element, i) => {
                    // iterate array and change places
                    if (i === index - 1) {
                        return (this.localValue || [])[index];
                    } else if (i === index) {
                        return (this.localValue || [])[index - 1];
                    } else {
                        return element;
                    }
                });
            }
        }
        this.$emit('input', this.localValue);
    }

    onChildMoveDown(movedItem: DisguiseDto.StructureDto<any>) {
        if (this.localValue) {
            const index = this.localValue.findIndex(
                (c) => c.id === movedItem.id
            );
            if (index < this.localValue.length) {
                this.localValue = this.localValue.map((element, i) => {
                    // iterate array and change places
                    if (i === index) {
                        return this.localValue[index + 1];
                    } else if (i === index + 1) {
                        return this.localValue[index];
                    } else {
                        return element;
                    }
                });
            }
        }
        this.$emit('input', this.localValue);
    }

    onChildDelete(movedItem: DisguiseDto.StructureDto<any>) {
        if (this.localValue) {
            const index = this.localValue.findIndex(
                (c) => c.id === movedItem.id
            );
            if (index >= 0) {
                this.localValue.splice(index, 1);
            }
        }
        this.$emit('input', this.localValue);
    }
}
